import React from 'react';




interface Update {
  id: number;
  type: 'regulatory' | 'product' | 'partnership';
  title: string;
  description: string;
  date: string;
  icon: string;
  image: string;
  alt: string;
}

const updates: Update[] = [
{
  id: 1,
  type: 'regulatory',
  title: 'New EU-GMP Certification Achieved',
  description: 'Successfully obtained EU-GMP certification for our expanded manufacturing facility, enabling enhanced product offerings across European markets.',
  date: 'December 2025',
  icon: 'ShieldCheckIcon',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e5a8dc32-1764675785314.png",
  alt: 'European Union pharmaceutical certification documents with official stamps and regulatory approval seals'
},
{
  id: 2,
  type: 'product',
  title: 'Launch of Advanced Oncology Portfolio',
  description: 'Introducing 50+ new oncology products with WHO-GMP approval, expanding our specialized therapeutic offerings.',
  date: 'November 2025',
  icon: 'BeakerIcon',
  image: "https://images.unsplash.com/photo-1582719471216-d2e7e332e19c",
  alt: 'Advanced oncology medication vials and pharmaceutical research equipment in modern laboratory setting'
},
{
  id: 3,
  type: 'partnership',
  title: 'Strategic Alliance with Latin American Distributors',
  description: 'Formed partnerships with leading distributors across 8 Latin American countries, strengthening our regional presence.',
  date: 'October 2025',
  icon: 'HandshakeIcon',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1955986da-1765047710334.png",
  alt: 'Business professionals shaking hands in modern office with international flags and partnership documents'
}];


export default function LatestUpdates() {
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'regulatory':
        return 'bg-success/10 text-success';
      case 'product':
        return 'bg-primary/10 text-primary';
      case 'partnership':
        return 'bg-secondary/10 text-secondary';
      default:
        return 'bg-muted text-textSecondary';
    }
  };

  const getTypeLabel = (type: string) => {
    switch (type) {
      case 'regulatory':
        return 'Regulatory Update';
      case 'product':
        return 'Product Launch';
      case 'partnership':
        return 'Partnership';
      default:
        return 'Update';
    }
  };

  return;



























































}